export default __webpack_public_path__ + "static/Measurement-&-parameters-94c4730aaba4ab728555266ea1af7d3d.webp";